// Liao 2.0 PDP interactions: gallery thumbs, purchase-plan picker
// (writes selling_plan + quantity into the real product form), CTA price
// text, and the sticky cart bar reveal. The form itself is the vendor
// <product-form> element (product-form.js) so add-to-cart flows through
// the existing AJAX + cart drawer machinery.
(function () {
  function money(cents) {
    var v = cents / 100;
    return '$' + (v % 1 === 0 ? v.toFixed(0) : v.toFixed(2));
  }

  // Two-axis buy box: quantity above, frequency below. The two axes are
  // independent, so the four combinations are precomputed in Liquid and
  // handed over as a JSON island. Every visible price is rewritten on each
  // change, including the price shown ON the other axis's options, so both
  // axes always preview the real consequence of switching.
  function initBuyBox(root) {
    var axes = root.querySelector('[data-liao-axes]');
    if (!axes || axes.dataset.liaoInit) return;

    var island = axes.querySelector('[data-liao-cells]');
    if (!island) return;
    var cells;
    try {
      cells = JSON.parse(island.textContent);
    } catch (err) {
      return;
    }
    axes.dataset.liaoInit = '1';

    var labels = cells.labels || {};
    var form = root.querySelector('form[data-type="add-to-cart-form"]');
    var planInput = form.querySelector('input[name="selling_plan"]');
    var qtyInput = form.querySelector('input[name="quantity"]');
    var ctaPrices = document.querySelectorAll('[data-liao-cta-price]');
    var planLabels = document.querySelectorAll('[data-liao-plan-label]');

    var groups = {};
    axes.querySelectorAll('[data-liao-axis]').forEach(function (group) {
      groups[group.dataset.liaoAxis] = group;
    });
    if (!groups.qty || !groups.freq) return;

    function cell(qty, freq) {
      return cells[qty + '-' + freq];
    }

    var state = {
      qty: groups.qty.dataset.liaoStart || 'single',
      freq: groups.freq.dataset.liaoStart || 'once',
    };

    // A combination whose selling plan does not exist must never be
    // selectable. Fall back along the frequency axis first, since one time
    // is always available.
    function normalize() {
      var c = cell(state.qty, state.freq);
      if (!c || !c.available) state.freq = 'once';
      if (!cell(state.qty, state.freq)) state.qty = 'single';
    }

    function setShip(el, c) {
      if (!el) return;
      var text = c.freeShip ? labels.shipFree || '' : labels.shipPaid || '';
      el.hidden = !text;
      el.textContent = text;
      el.classList.toggle('is-free', !!c.freeShip);
    }

    function setLine(el, text) {
      if (!el) return;
      el.hidden = !text;
      el.textContent = text || '';
    }

    // "($44.96 / bottle)" under a card price. Only ever shown on a multi
    // bottle cell, where the unit price is a different number from the total.
    function setEach(el, c) {
      if (!el) return;
      var show = c.qty > 1 && labels.eachParen;
      el.hidden = !show;
      el.textContent = show ? '(' + money(c.perBottle) + ' ' + labels.eachParen + ')' : '';
    }

    // The frequency axis renders as a single switch rather than two radios
    // (Pietro 2026-09-12). Same two values underneath, so deep links,
    // normalize() and the form writes are all unchanged.
    var freqIsToggle = groups.freq.hasAttribute('data-liao-toggle');

    function renderToggle() {
      var opt = groups.freq.querySelector('[data-liao-opt]');
      if (!opt) return;
      var c = cell(state.qty, 'sub');
      var onceCell = cell(state.qty, 'once');

      var unavailable = !c || !c.available;
      groups.freq.hidden = unavailable;
      if (unavailable) return;

      var isOn = state.freq === 'sub';
      opt.setAttribute('aria-checked', isOn ? 'true' : 'false');
      opt.classList.toggle('is-selected', isOn);

      var priceEl = opt.querySelector('[data-liao-opt-price]');
      if (priceEl) priceEl.textContent = money(c.total);

      // The title follows the quantity (Pietro 2026-09-28): "Subscribe &
      // Save 15%" on 1 bottle, "Subscribe & Save extra 15%" on 3.
      var titleEl = opt.querySelector('[data-liao-sub-title]');
      if (titleEl) {
        var title = c.qty > 1 && labels.subTitleBundle ? labels.subTitleBundle : labels.subTitle;
        if (title) titleEl.textContent = title;
      }

      // "$110.25 every 90 days ($36.75 / bottle)." States the recurring
      // charge next to the price (PDP audit 2026-09-27).
      var restEl = opt.querySelector('[data-liao-sub-rest]');
      if (restEl) {
        var rest = c.recur ? ' ' + c.recur : '';
        if (c.qty > 1 && labels.eachParen) {
          rest += ' (' + money(c.perBottle) + ' ' + labels.eachParen + ')';
        }
        restEl.textContent = rest + '.';
      }

      // The unlock promise only appears where there is something to unlock.
      // On the 3 pack the one time order already ships free.
      var shipEl = opt.querySelector('[data-liao-sub-ship]');
      if (shipEl) shipEl.hidden = !(onceCell && !onceCell.freeShip);

      var metaEl = opt.querySelector('[data-liao-sub-meta]');
      if (metaEl) {
        // The cadence now lives in the price sentence above; a cell without
        // recurring wording keeps its cadence line here.
        var bits = [];
        if (c.cadence && !c.recur) bits.push(c.cadence + '.');
        if (c.note) bits.push(c.note + '.');
        metaEl.textContent = bits.join(' ');
      }
    }

    // One sentence that states the whole answer, so nobody has to multiply
    // or compare. Free shipping leads the outcome clauses because it is a
    // benefit; paid shipping trails them because it is the caveat.
    var summaryEl = root.querySelector('[data-liao-summary]');

    function renderSummary(c) {
      if (!summaryEl) return;
      var parts = [money(c.total) + ' ' + (labels.today || '') + '.'];
      if (c.qty > 1) parts.push(money(c.perBottle) + ' ' + (labels.perBottle || '') + '.');
      if (c.save > 0) parts.push((labels.save || '') + ' ' + money(c.save) + '.');
      if (c.freeShip) {
        if (labels.shipFree) parts.push(labels.shipFree + '.');
        if (c.cadence) parts.push(c.cadence + '.');
      } else {
        if (c.cadence) parts.push(c.cadence + '.');
        if (labels.shipPaid) parts.push(labels.shipPaid + '.');
      }
      summaryEl.textContent = parts.join(' ');
    }

    function render() {
      normalize();
      var selected = cell(state.qty, state.freq);

      Object.keys(groups).forEach(function (axis) {
        if (axis === 'freq' && freqIsToggle) return;
        var current = state[axis];
        groups[axis].querySelectorAll('[data-liao-opt]').forEach(function (opt) {
          var value = opt.dataset.value;
          // The price on an option is the price you would actually pay if
          // you picked it, holding the other axis where it currently is.
          //
          // Exception, and the whole point of the card + toggle layout: when
          // frequency is a switch, the cards hold the ONE TIME price and the
          // toggle underneath shows what subscribing turns it into. Letting
          // the card price move with the switch showed the same number in two
          // places and made the toggle look like it did nothing.
          var c =
            axis === 'qty'
              ? cell(value, freqIsToggle ? 'once' : state.freq)
              : cell(state.qty, value);
          var isOn = value === current;
          opt.classList.toggle('is-selected', isOn);
          opt.setAttribute('aria-checked', isOn ? 'true' : 'false');
          // Roving tabindex: a radio group is one tab stop, arrows move
          // inside it.
          opt.tabIndex = isOn ? 0 : -1;

          var unavailable = !c || !c.available;
          opt.disabled = unavailable;
          opt.classList.toggle('is-unavailable', unavailable);
          if (unavailable) {
            opt.setAttribute('aria-disabled', 'true');
            return;
          }
          opt.removeAttribute('aria-disabled');

          // Quantity rows price per bottle ("$42.46 each"), frequency rows
          // price the whole order. A single bottle needs no "each", the two
          // numbers are the same.
          var priceEl = opt.querySelector('[data-liao-opt-price]');
          if (priceEl) {
            if (opt.dataset.priceMode === 'perBottle') {
              priceEl.textContent =
                money(c.perBottle) + (c.qty > 1 && labels.each ? ' ' + labels.each : '');
            } else {
              // "$134.88 total" on a multi bottle card, plain "$49.95" on a
              // single, where "total" would be noise.
              priceEl.textContent =
                money(c.total) + (c.qty > 1 && labels.totalSuffix ? ' ' + labels.totalSuffix : '');
            }
          }

          setEach(opt.querySelector('[data-liao-opt-each]'), c);

          var compareEl = opt.querySelector('[data-liao-opt-compare]');
          if (compareEl) {
            var saved = c.compare - c.total;
            compareEl.hidden = saved <= 0;
            compareEl.textContent = money(c.compare);
          }

          // The pill obeys the same rule as the price: it states the saving
          // you would get on THIS option with the other axis left alone. So
          // "3 bottles" reads 15% next to one time and 30% next to
          // subscribe, and never both.
          var flagEl = opt.querySelector('[data-liao-opt-flag]');
          if (flagEl) {
            // Fixed pill overrides (Pietro 2026-09-02): the computed percent
            // measured both pills against the full list price, so 3 bottles +
            // subscribe showed 30% twice and read like 60% off. When an
            // override is set, the pill is a constant label that never
            // recomputes with the other axis.
            var override = '';
            if (axis === 'qty' && value === 'bundle' && labels.flagBundle) {
              override = labels.flagBundle;
            } else if (axis === 'freq' && value === 'sub' && labels.flagSub) {
              override = labels.flagSub;
            }
            if (override) {
              flagEl.hidden = false;
              flagEl.textContent = override;
            } else {
              var pct = c.savePct || 0;
              flagEl.hidden = pct <= 0;
              // The subscribe pill says "extra" because its percent stacks on
              // whatever the quantity row already saved.
              var pill =
                axis === 'freq' && value === 'sub' && labels.savePillSub
                  ? labels.savePillSub
                  : labels.savePill;
              flagEl.textContent = (pill || '') + ' ' + pct + '%';
            }
          }

          setShip(opt.querySelector('[data-liao-opt-ship]'), c);
          setLine(opt.querySelector('[data-liao-opt-cadence]'), c.cadence);
          setLine(opt.querySelector('[data-liao-opt-note]'), c.note);
        });
      });

      if (freqIsToggle) renderToggle();

      renderSummary(selected);

      planInput.value = selected.plan || '';
      planInput.disabled = !selected.plan;
      qtyInput.value = String(selected.qty || 1);
      ctaPrices.forEach(function (el) {
        el.textContent = money(selected.total);
      });
      planLabels.forEach(function (el) {
        el.textContent = selected.label || '';
      });
    }

    // Plan deep links. Any anchor shaped #plan-<qty>-<freq> selects that
    // cell and scrolls back to the buy box, so a CTA lower on the page
    // ("Start the 90-Day Plan", "Try One Bottle") never dumps the shopper
    // at the top with the default cell still selected.
    function applyPlanHash(hash) {
      var m = /^#plan-(single|bundle)-(once|sub)$/.exec(hash || '');
      if (!m) return false;
      var c = cell(m[1], m[2]);
      if (!c || !c.available) return false;
      state.qty = m[1];
      state.freq = m[2];
      render();
      return true;
    }
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[href^="#plan-"]') : null;
      if (!a) return;
      if (applyPlanHash(a.getAttribute('href'))) {
        e.preventDefault();
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
    if (applyPlanHash(window.location.hash)) {
      root.scrollIntoView();
    }

    if (freqIsToggle) {
      var toggleOpt = groups.freq.querySelector('[data-liao-opt]');
      if (toggleOpt) {
        toggleOpt.addEventListener('click', function () {
          state.freq = state.freq === 'sub' ? 'once' : 'sub';
          render();
        });
      }
    }

    Object.keys(groups).forEach(function (axis) {
      if (axis === 'freq' && freqIsToggle) return;
      var opts = Array.prototype.slice.call(groups[axis].querySelectorAll('[data-liao-opt]'));
      opts.forEach(function (opt, i) {
        opt.addEventListener('click', function () {
          if (opt.disabled) return;
          state[axis] = opt.dataset.value;
          render();
        });
        opt.addEventListener('keydown', function (e) {
          var dir = e.key === 'ArrowRight' || e.key === 'ArrowDown' ? 1
            : e.key === 'ArrowLeft' || e.key === 'ArrowUp' ? -1 : 0;
          if (!dir) return;
          e.preventDefault();
          // Step to the next selectable option, wrapping around.
          for (var n = 1; n <= opts.length; n++) {
            var next = opts[(i + dir * n + opts.length * n) % opts.length];
            if (next && !next.disabled) {
              state[axis] = next.dataset.value;
              render();
              next.focus();
              return;
            }
          }
        });
      });
    });

    render();

    // Gallery: the main image is a horizontal scroll-snap track, one
    // slide per media item. Thumbs scroll the track, scrolling the track
    // re-marks the thumbs. Every slide is exactly one track-width wide,
    // so the active index is scrollLeft / clientWidth — no geometry
    // guessing, and swipe/trackpad/arrow all resolve the same way.
    var galleryMain = root.querySelector('[data-liao-gallery-main]');
    var galleryTrack = root.querySelector('[data-liao-gallery-track]');
    var slides = galleryTrack
      ? Array.prototype.slice.call(galleryTrack.querySelectorAll('[data-liao-slide]'))
      : [];
    var thumbBtns = Array.prototype.slice.call(root.querySelectorAll('[data-liao-thumb]'));
    var thumbRow = root.querySelector('.liao-pdp-gallery__thumbs');
    var activeIndex = 0;
    // Side arrows on the main image (gallery_arrows setting, Pietro
    // 2026-10-22). They step one slide and fade out at either end.
    var stepPrev = root.querySelector('[data-liao-slide-prev]');
    var stepNext = root.querySelector('[data-liao-slide-next]');

    function syncSteps() {
      if (stepPrev) stepPrev.disabled = activeIndex <= 0;
      if (stepNext) stepNext.disabled = activeIndex >= slides.length - 1;
    }

    function scrollThumbIntoView(i) {
      var thumb = thumbBtns[i];
      if (!thumb || !thumbRow) return;
      var left = thumb.offsetLeft;
      var right = left + thumb.offsetWidth;
      if (left < thumbRow.scrollLeft) {
        thumbRow.scrollTo({ left: Math.max(0, left - 12), behavior: 'smooth' });
      } else if (right > thumbRow.scrollLeft + thumbRow.clientWidth) {
        thumbRow.scrollTo({ left: right - thumbRow.clientWidth + 12, behavior: 'smooth' });
      }
    }

    function setActive(i, moveTrack) {
      if (!slides.length) return;
      activeIndex = Math.min(slides.length - 1, Math.max(0, i));
      thumbBtns.forEach(function (t, ti) {
        t.classList.toggle('is-active', ti === activeIndex);
      });
      var slide = slides[activeIndex];
      if (galleryMain && slide && slide.dataset.zoom) {
        galleryMain.dataset.zoom = slide.dataset.zoom;
      }
      if (moveTrack && galleryTrack) {
        galleryTrack.scrollTo({ left: activeIndex * galleryTrack.clientWidth, behavior: 'smooth' });
      }
      scrollThumbIntoView(activeIndex);
      syncSteps();
    }

    thumbBtns.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { setActive(i, true); });
    });

    // The arrows sit inside the main image, which opens the lightbox on
    // click and on Enter/Space, so both events stop here.
    [[stepPrev, -1], [stepNext, 1]].forEach(function (pair) {
      var btn = pair[0];
      if (!btn) return;
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        setActive(activeIndex + pair[1], true);
      });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') e.stopPropagation();
      });
    });

    if (galleryTrack && slides.length) {
      var trackScrollTimer = null;
      galleryTrack.addEventListener('scroll', function () {
        if (trackScrollTimer) clearTimeout(trackScrollTimer);
        // Settle first: mid-swipe the index flickers between neighbours.
        trackScrollTimer = setTimeout(function () {
          var width = galleryTrack.clientWidth || 1;
          var i = Math.round(galleryTrack.scrollLeft / width);
          if (i !== activeIndex) setActive(i, false);
        }, 70);
      }, { passive: true });

      // A resize changes slide width, so the snap offset has to be
      // re-derived or the track lands between two images.
      window.addEventListener('resize', function () {
        galleryTrack.scrollLeft = activeIndex * galleryTrack.clientWidth;
      });

      setActive(0, false);
    }

    // Thumb carousel arrows: step ~70% of the visible row per click,
    // fade the arrow that has nowhere left to go, and only show the
    // pair at all when the row actually overflows.
    var nav = root.querySelector('[data-liao-thumbs-nav]');
    if (nav && !nav.dataset.liaoNavInit) {
      nav.dataset.liaoNavInit = '1';
      var row = nav.querySelector('.liao-pdp-gallery__thumbs');
      var prevBtn = nav.querySelector('[data-liao-thumbs-prev]');
      var nextBtn = nav.querySelector('[data-liao-thumbs-next]');

      function syncArrows() {
        var max = row.scrollWidth - row.clientWidth;
        nav.classList.toggle('has-overflow', max > 4);
        prevBtn.disabled = row.scrollLeft <= 2;
        nextBtn.disabled = row.scrollLeft >= max - 2;
      }

      function step(dir) {
        row.scrollBy({ left: dir * Math.round(row.clientWidth * 0.7), behavior: 'smooth' });
      }

      prevBtn.addEventListener('click', function () { step(-1); });
      nextBtn.addEventListener('click', function () { step(1); });
      row.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      syncArrows();
    }

    // Sticky bar (reinstated 2026-09-14 as a plan button): show once the
    // whole product info section has scrolled off the top, hide again when
    // any of it is back in view. Its button scrolls to the plan cards
    // rather than submitting the form.
    var bar = document.querySelector('[data-liao-sticky-bar]');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var e = entries[0];
        bar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.bottom <= 0);
      }).observe(root);
      var planLink = bar.querySelector('[data-liao-sticky-plan]');
      if (planLink) {
        planLink.addEventListener('click', function (e) {
          var target = document.getElementById('choose-plan') || axes;
          if (!target) return;
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        });
      }
    }
  }

  // 90-day timeline: milestones activate on scroll, terracotta progress
  // line draws down the rail scrubbed to scroll position (mirrors the
  // design export's GSAP spec). Reduced motion / no GSAP = static full
  // state via .liao-tl-static.
  function initTimeline() {
    document.querySelectorAll('.liao-pdp-timeline').forEach(function (tl) {
      if (tl.dataset.liaoTlInit) return;
      tl.dataset.liaoTlInit = '1';
      var items = tl.querySelectorAll('.liao-pdp-timeline__item');
      var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reduced || typeof gsap === 'undefined' || typeof ScrollTrigger === 'undefined') {
        tl.classList.add('liao-tl-static');
        items.forEach(function (item) { item.classList.add('is-active'); });
        return;
      }
      gsap.registerPlugin(ScrollTrigger);
      tl.classList.add('liao-tl-armed');
      items.forEach(function (item) {
        ScrollTrigger.create({
          trigger: item,
          start: 'top 62%',
          onEnter: function () { item.classList.add('is-active'); },
          onLeaveBack: function () { item.classList.remove('is-active'); },
        });
      });
      var progress = tl.querySelector('.liao-pdp-timeline__progress');
      if (progress) {
        gsap.fromTo(progress, { scaleY: 0 }, {
          scaleY: 1,
          ease: 'none',
          scrollTrigger: { trigger: tl, start: 'top 60%', end: 'bottom 62%', scrub: 0.5 },
        });
      }
    });
  }

  // Supplement facts popup: native <dialog>, closes on X, backdrop
  // click, or Esc (built into dialog).
  function initFactsModal() {
    document.querySelectorAll('[data-liao-facts-open]').forEach(function (btn) {
      if (btn.dataset.liaoFactsInit) return;
      btn.dataset.liaoFactsInit = '1';
      var modal = btn.parentElement.querySelector('[data-liao-facts-modal]');
      if (!modal || typeof modal.showModal !== 'function') return;
      btn.addEventListener('click', function () { modal.showModal(); });
      modal.querySelector('[data-liao-facts-close]').addEventListener('click', function () { modal.close(); });
      modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
    });
  }

  // Gallery lightbox: click/tap the main image → full-screen <dialog>.
  // Desktop: click magnifier (zoom 2.5x into the clicked point, click
  // again to reset). Mobile: pinch-to-zoom 1x-4x with one-finger pan
  // while zoomed; a plain tap also toggles zoom. Esc / X / tapping the
  // dark stage closes.
  function initLightbox(root) {
    var wrap = root.querySelector('[data-liao-gallery-main]');
    var dialog = root.querySelector('[data-liao-lightbox]');
    if (!wrap || !dialog || dialog.dataset.liaoLbInit) return;
    if (typeof dialog.showModal !== 'function') return;
    dialog.dataset.liaoLbInit = '1';

    var stage = dialog.querySelector('[data-liao-lightbox-stage]');
    var img = dialog.querySelector('[data-liao-lightbox-img]');
    var closeBtn = dialog.querySelector('[data-liao-lightbox-close]');
    var lbTrack = wrap.querySelector('[data-liao-gallery-track]');

    var lbSlides = lbTrack
      ? Array.prototype.slice.call(lbTrack.querySelectorAll('[data-liao-slide]'))
      : [];
    var lbIndex = 0;
    var swiping = false;
    var swipeDX = 0;

    // Which slide is on screen right now. Slides are exactly one
    // track-width wide, so the index falls out of the scroll offset.
    function activeSlide() {
      if (!lbSlides.length) return null;
      var i = Math.round(lbTrack.scrollLeft / (lbTrack.clientWidth || 1));
      return lbSlides[Math.min(lbSlides.length - 1, Math.max(0, i))];
    }

    function slideSource(i) {
      var s = lbSlides[i];
      if (!s) return null;
      var im = s.querySelector('img');
      return { src: s.dataset.zoom || (im && im.src) || '', alt: (im && im.alt) || '' };
    }

    // Warm the neighbours so a swipe does not flash an empty frame.
    function preloadNeighbours(i) {
      [i - 1, i + 1].forEach(function (n) {
        var d = slideSource(n);
        if (d && d.src) {
          var pre = new Image();
          pre.src = d.src;
        }
      });
    }

    // Show image i, entering from `dir` (1 = came from the right, so the
    // user swiped forward). The underlying track is moved to match, so
    // closing the lightbox lands on the image the user ended on and the
    // thumb rail is already correct.
    function showIndex(i, dir) {
      var data = slideSource(i);
      if (!data || i === lbIndex) return false;
      var w = stage.clientWidth || window.innerWidth;
      lbIndex = i;

      dialog.classList.add('is-gesturing'); // no transition for the jump
      img.src = data.src;
      img.alt = data.alt;
      scale = 1;
      ty = 0;
      tx = dir * w;
      apply();

      // Two frames: let the off-screen position paint before animating in.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          dialog.classList.remove('is-gesturing');
          scale = 1;
          tx = 0;
          ty = 0;
          apply();
        });
      });

      if (lbTrack) {
        lbTrack.scrollTo({ left: i * lbTrack.clientWidth, behavior: 'auto' });
      }
      preloadNeighbours(i);
      return true;
    }

    var MAX_SCALE = 4;
    var CLICK_SCALE = 2.5;
    var scale = 1;
    var tx = 0;
    var ty = 0;

    function apply() {
      img.style.transform = 'translate(' + tx + 'px, ' + ty + 'px) scale(' + scale + ')';
      dialog.classList.toggle('is-zoomed', scale > 1.02);
    }

    function clampPan() {
      var mx = Math.max(0, (img.offsetWidth * scale - stage.clientWidth) / 2);
      var my = Math.max(0, (img.offsetHeight * scale - stage.clientHeight) / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    }

    function reset() {
      scale = 1;
      tx = 0;
      ty = 0;
      apply();
    }

    function open(e) {
      // Prefer the slide that was actually activated, so a keyboard tab
      // to slide 5 plus Enter opens slide 5 and not whatever the track
      // last settled on.
      var slide =
        (e && e.target && e.target.closest && e.target.closest('[data-liao-slide]')) ||
        activeSlide();
      var srcImg = slide ? slide.querySelector('img') : wrap.querySelector('img');
      img.src = (slide && slide.dataset.zoom) || wrap.dataset.zoom || (srcImg && srcImg.src) || '';
      img.alt = (srcImg && srcImg.alt) || '';
      lbIndex = Math.max(0, lbSlides.indexOf(slide));
      swiping = false;
      swipeDX = 0;
      preloadNeighbours(lbIndex);
      reset();
      dialog.showModal();
      document.documentElement.classList.add('liao-lightbox-open');
    }

    wrap.addEventListener('click', open);
    wrap.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        open(e);
      }
    });
    closeBtn.addEventListener('click', function () { dialog.close(); });
    dialog.addEventListener('close', function () {
      document.documentElement.classList.remove('liao-lightbox-open');
      reset();
    });
    stage.addEventListener('click', function (e) {
      if (e.target === stage) dialog.close();
    });

    // A pointer that dragged or pinched must not fire the click toggle.
    var moved = false;

    img.addEventListener('click', function (e) {
      if (moved) {
        moved = false;
        return;
      }
      if (scale > 1.02) {
        reset();
        return;
      }
      var r = img.getBoundingClientRect();
      scale = CLICK_SCALE;
      tx = -(e.clientX - (r.left + r.width / 2)) * scale;
      ty = -(e.clientY - (r.top + r.height / 2)) * scale;
      clampPan();
      apply();
    });

    var pointers = new Map();
    var gestureStart = null;

    function midAndDist(pts) {
      if (pts.length >= 2) {
        return {
          mx: (pts[0].x + pts[1].x) / 2,
          my: (pts[0].y + pts[1].y) / 2,
          d: Math.hypot(pts[1].x - pts[0].x, pts[1].y - pts[0].y),
        };
      }
      return { mx: pts[0].x, my: pts[0].y, d: 0 };
    }

    function startGesture() {
      gestureStart = {
        scale: scale,
        tx: tx,
        ty: ty,
        pts: Array.from(pointers.values()).map(function (p) {
          return { x: p.x, y: p.y };
        }),
      };
    }

    img.addEventListener('pointerdown', function (e) {
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });
      if (pointers.size === 1) moved = false;
      if (e.pointerType === 'touch' || scale > 1.02) {
        try { img.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
      }
      startGesture();
    });

    img.addEventListener('pointermove', function (e) {
      var p = pointers.get(e.pointerId);
      if (!p || !gestureStart) return;
      p.x = e.clientX;
      p.y = e.clientY;
      var pts = Array.from(pointers.values());
      var stageR = stage.getBoundingClientRect();
      var cx = stageR.left + stageR.width / 2;
      var cy = stageR.top + stageR.height / 2;

      if (pts.length >= 2) {
        // Pinch: rescale about the finger midpoint so the image point
        // under the fingers stays under them.
        dialog.classList.add('is-gesturing');
        moved = true;
        var s0 = midAndDist(gestureStart.pts);
        var s1 = midAndDist(pts);
        var newScale = Math.min(MAX_SCALE, Math.max(1, gestureStart.scale * (s1.d / (s0.d || 1))));
        var dx0 = (s0.mx - cx - gestureStart.tx) / gestureStart.scale;
        var dy0 = (s0.my - cy - gestureStart.ty) / gestureStart.scale;
        scale = newScale;
        tx = (s1.mx - cx) - dx0 * scale;
        ty = (s1.my - cy) - dy0 * scale;
        clampPan();
        apply();
        e.preventDefault();
      } else if (scale > 1.02) {
        // One-finger (or mouse) pan while zoomed.
        var start = gestureStart.pts[0];
        var ddx = pts[0].x - start.x;
        var ddy = pts[0].y - start.y;
        if (Math.abs(ddx) + Math.abs(ddy) > 6) {
          dialog.classList.add('is-gesturing');
          moved = true;
        }
        tx = gestureStart.tx + ddx;
        ty = gestureStart.ty + ddy;
        clampPan();
        apply();
        e.preventDefault();
      } else if (lbSlides.length > 1) {
        // One finger at rest: the only gesture slot left, since two
        // fingers is pinch and one finger while zoomed is pan. A
        // horizontal drag here walks the gallery, so nobody has to
        // close the lightbox, swipe the page and reopen.
        var s0p = gestureStart.pts[0];
        var sdx = pts[0].x - s0p.x;
        var sdy = pts[0].y - s0p.y;
        if (!swiping && Math.abs(sdx) > 10 && Math.abs(sdx) > Math.abs(sdy)) {
          swiping = true;
          moved = true;
          dialog.classList.add('is-gesturing');
        }
        if (swiping) {
          // Rubber band at the two ends so the gallery feels bounded.
          var atEdge =
            (sdx > 0 && lbIndex === 0) || (sdx < 0 && lbIndex === lbSlides.length - 1);
          swipeDX = atEdge ? sdx * 0.3 : sdx;
          tx = swipeDX;
          ty = 0;
          apply();
          e.preventDefault();
        }
      }
    });

    function endPointer(e) {
      if (!pointers.has(e.pointerId)) return;
      pointers.delete(e.pointerId);
      if (pointers.size === 0) {
        dialog.classList.remove('is-gesturing');
        gestureStart = null;

        if (swiping) {
          // Commit past ~18% of the stage, otherwise spring back.
          var w = stage.clientWidth || window.innerWidth;
          var forward = swipeDX < 0;
          var target = lbIndex + (forward ? 1 : -1);
          var committed =
            Math.abs(swipeDX) > Math.max(40, w * 0.18) &&
            target >= 0 &&
            target < lbSlides.length &&
            showIndex(target, forward ? 1 : -1);
          if (!committed) {
            scale = 1;
            tx = 0;
            ty = 0;
            apply();
          }
          swiping = false;
          swipeDX = 0;
          return;
        }

        if (scale < 1.06) reset();
      } else {
        startGesture();
      }
    }

    img.addEventListener('pointerup', endPointer);
    img.addEventListener('pointercancel', endPointer);

    // Desktop has no swipe, so arrow keys walk the gallery instead.
    dialog.addEventListener('keydown', function (e) {
      if (lbSlides.length < 2 || scale > 1.02) return;
      if (e.key === 'ArrowRight' && lbIndex < lbSlides.length - 1) {
        e.preventDefault();
        showIndex(lbIndex + 1, 1);
      } else if (e.key === 'ArrowLeft' && lbIndex > 0) {
        e.preventDefault();
        showIndex(lbIndex - 1, -1);
      }
    });
  }

  function boot() {
    document.querySelectorAll('.liao-pdp-buy').forEach(initBuyBox);
    document.querySelectorAll('.liao-pdp-buy').forEach(initLightbox);
    initTimeline();
    initFactsModal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
